module.exports = __webpack_public_path__ + "static/video02-4177d67dc7046cf0c07587d503d79543.mp4";